// Stub module for React Native vector icons on web
// These packages are not needed for web builds as we use lucide-react icons instead

// Export empty/default components to prevent module resolution errors
const StubIcon = () => null;

export default StubIcon;
export { StubIcon };
export const MaterialCommunityIcons = StubIcon;
export const MaterialDesignIcons = StubIcon;
